import Navbar from './NavBar.js'
// import ExpSection from './ExpSection'
// import SkillsetSection from './SkillsetSection'
// import FoooterTiles from './FooterSection'
import '../assets/css/DesignSection.css'
import '../assets/css/AboutHeroSection.css'
import DesignSection from './DesignSection'
import FoooterTiles from './FooterSection'
import Fade from 'react-reveal/Fade';


import i1 from '../assets/img/30DayDesign/1.png'
import i2 from '../assets/img/30DayDesign/2.png'
import i3 from '../assets/img/30DayDesign/3.png'
import i4 from '../assets/img/30DayDesign/4.png'
import i5 from '../assets/img/30DayDesign/5.png'
import i6 from '../assets/img/30DayDesign/6.png'
import i7 from '../assets/img/30DayDesign/7.png'
import i8 from '../assets/img/30DayDesign/8.png'
import i9 from '../assets/img/30DayDesign/9.png'
import i10 from '../assets/img/30DayDesign/10.png'
import i11 from '../assets/img/30DayDesign/11.png'
import i12 from '../assets/img/30DayDesign/12.png'
import i13 from '../assets/img/30DayDesign/13.png'
import i14 from '../assets/img/30DayDesign/14.png'
import i15 from '../assets/img/30DayDesign/15.png'
import i16 from '../assets/img/30DayDesign/16.png'
import i17 from '../assets/img/30DayDesign/17.png'
import i18 from '../assets/img/30DayDesign/18.png'
import i19 from '../assets/img/30DayDesign/19.png'
import i20 from '../assets/img/30DayDesign/20.png'
import i21 from '../assets/img/30DayDesign/21.png'
import i22 from '../assets/img/30DayDesign/22.png'
import i23 from '../assets/img/30DayDesign/23.png'
import i24 from '../assets/img/30DayDesign/24.png'
import i25 from '../assets/img/30DayDesign/25.png'
import i26 from '../assets/img/30DayDesign/26.png'
import i27 from '../assets/img/30DayDesign/27.png'
import i28 from '../assets/img/30DayDesign/28.png'
import i29 from '../assets/img/30DayDesign/29.png'
import i30 from '../assets/img/30DayDesign/30.png'




const arr = [{ url : i1 , title : 'Website for blogger'},
  { url : i2 , title : 'Startup for Freelance Designer'},
  { url : i3 , title : 'A goal-oriented task list app'},
  { url : i4 , title : 'A startup for college students'},
  { url : i5 , title : 'A search engine for product and services'},
  { url : i6 , title : 'Construction Site'},
  { url : i7 , title : 'Send and Receive money thorugh application'},
  { url : i8 , title : 'Traveller site for planning trip and find best route'},
  { url : i9 , title : 'Restaurant Application'},
  { url : i10 , title : 'Find the best healthcare professional'},
  { url : i11 , title : 'Furniture and home decor site'},
  { url : i12 , title : 'Linkedin Profile Creator'},
  { url : i13 , title : 'Blood Donation register site'},
  { url : i14 , title : 'Car buyers and sellers'},
  { url : i15 , title : 'Restaurant table booker'},
  { url : i16 , title : 'Find your dream home'},
  { url : i17 , title : 'A text to speech app'},
  { url : i18 , title : 'Hire Data-Scientist Site'},
  { url : i19 , title : 'Healthcare AI Platform'},
  { url : i20 , title : 'A 3D printted eyewear company'},
  { url : i21 , title : 'Private messaging app'},
  { url : i22 , title : 'Video creator tools'},
  { url : i23 , title : 'Dating application'},
  { url : i24 , title : 'To-do application'},
  { url : i25 , title : 'Redesign To-do application'},
  { url : i26 , title : 'e-Commerce Site'},
  { url : i27 , title : 'Online Book Store'},
  { url : i28 , title : 'A site for mathematics lover'},
  { url : i29 , title : 'A site for developers'},
  { url : i30 , title : 'A site for biker'},
];

function Projects() {
  return (
    <div className="heroSectionDesign">
      <Navbar />
      <div className="sec9 container">
        <h1>30 Days UI Design Challenge for HeroSection</h1>
        <div className="row designSection">
        {arr.map((item, index) => 
                
                <DesignSection url={item.url} title={item.title} indx={index+1} />
        )}
        </div>
      </div>
      <Fade left>
        <section>
          <FoooterTiles />
        </section>
      </Fade>
    </div>
  );
}

export default Projects;
